import React from 'react';
import {makeStyles} from '@mui/styles';
import {Card, CardContent, Link, Typography} from '@mui/material';

const useStyles = makeStyles({
    footer: {
        padding: '40px',
        marginTop: '32px',
        borderRadius: '0px !important'
    }
})

export default function Footer() {
    const classes = useStyles();
    return (
        <Card component={'footer'} className={classes.footer}>
            {/*<CardContent>
                <Typography variant="h6" component="h2" align="center">
                    NBA Stream | Watch Official Reddit NBA Streams Live
                </Typography>
                <Typography variant="body1" align="center">
                    Want to connect to NBA Streams then soccer streams is the right platform for you.Here you will be
                    able each detail from the match schedule to history, team summary,venue, news, pictures and live
                    streams. The site not only gets you the uninterrupted streams of the matches but much more. When you
                    are looking for the NBA streaming you may not be able to find the right link.However, we bring you
                    the right and workable links for sure. You can get the live streams anytime whenever there is a
                    schedule match or even get the videos.
                </Typography>
                <Typography variant="body1" align="center">
                    Search for live matches and videos
                    Soccer streams is not just a hub for you to watch live NBA matches. You can even look for more about
                    NBA like videos, pictures, scoring and much more. There is a live inflow of multiple information via
                    different source. We keep updating all the information you want to know about the teams, players and
                    others.It is your single access portal to look for the information that you cannot have at any one
                    site easily. Open access to all the latest pictures, previous videos and much more is a benefit.
                </Typography>
                <Typography variant="body1" align="center">
                    All you need to know about Reddit NBA Streams
                    The soccer streams brings you the complete information and entertainment that you need to know about
                    the NBA matches. Here you will get the news,pictures,match schedules point table,match summary and
                    much more. You can search for teams,matches,coaches and other important information on site. It is
                    not just a streaming site but also a complete hub for you to get the maximum sport news and more.
                </Typography>
                <Typography variant="body1" align="center">
                    Find the workable links
                    it is definitely hard to find the workable NBA Streams Reddit links that connects you live
                    matches.The site not only streams the matches but gives you the other links as well.Many of the
                    registered streamers with the site offer you the reliable streaming,pictures and new as well.You can
                    search for the required links or content through the search menu. It redirect to the workable secure
                    and bug free links direclty.You do not have to suffer from the fake links or bear the ad links too
                    much.
                </Typography>
                <Typography variant="body1" align="center">
                    Get yourself registered now!
                    To get all the Reddit NBA streams all you need to register yourself on site.It is not difficult at
                    all. By just paying the basic subscription fee, you can have the membership and will be able to
                    access the live streaming, matches and much more.Additionally, you can register as a streamer with
                    the website by following the required procedure ,Once you will accept the terms and conditions of
                    the site, you will be able to connect your streaming site with soccer streams.On the portal,you can
                    manage your tags and accessibility. It will help to generate more site traffic for you.
                </Typography>
            </CardContent>*/}
            <Typography variant="body2" color="text.secondary" align="center">
                {'Copyright © '}
                <Link color="inherit" href="https://redly.dev/">
                    Redly
                </Link>{' '}
                {new Date().getFullYear()}.
            </Typography>
        </Card>
    );
}